/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".file-preview-box[_ngcontent-%COMP%]{grid-template-columns:repeat(auto-fill,minmax(180px,1fr))}.file-preview-box[_ngcontent-%COMP%]   .file-preview[_ngcontent-%COMP%]{height:150px}"];
export { styles as styles };
